<template>
  <transition name="slide">   
      <b-card no-body>
        <b-card-header>
              Organization List
              <div class="pull-right">
                  <b-button size="sm" v-b-tooltip.hover variant="primary" title="Add New" @click.stop="add()">
                    <i class="fa fa-plus"></i> Add New
                  </b-button>
              </div>  
        </b-card-header>
        <b-card-body>
        <b-row>
          <b-col md="1">
              <b-form-select :options="pageOptions" v-model="perPage" />
          </b-col>
          <b-col md="4" offset-md="7">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''"><i class="fa fa-times-circle"></i></b-btn>
                  </b-input-group-append>
                </b-input-group>
          </b-col>  
        </b-row>
        <br/>   
        <b-table responsive show-empty id="orgtable" :busy.sync="isBusy" :filter="filter" :items="myProvider" :fields="fields" :current-page="currentPage" :per-page="perPage">
          
          <template v-slot:cell(orgindex)="data">
            <strong>{{data.item.orgindex}}</strong>
          </template>
          <template v-slot:cell(createddate)="data">
            {{data.item.createddate | dateTimeFormat }}
          </template>
          <template v-slot:cell(action)="data">
            <b-button-group>
                <b-button title="Edit" v-b-tooltip.hover size="sm" variant="primary" @click.stop="info(data.item)"><span> <i class="fa fa-edit"></i> Edit</span></b-button>
                <b-button title="Delete" v-b-tooltip.hover size="sm" variant="danger" @click.stop="del(data.item)"><span> <i class="fa fa-remove" ></i> Delete</span></b-button>
            </b-button-group>
          </template>
        </b-table>
        <nav v-if="totalRows>0">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card-body>
      </b-card>
  </transition>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex' 
import { getResponseMessages } from '../../_helpers';
export default {
  name: 'Organization_List',
  data: () => {
    return {
      itemsData: [],
      fields: [
        {key: 'orgindex',sortable:true,label: 'Org Index'},
        {key: 'orgname',sortable:true,label: 'Org Name'},
        {key: 'orgtypename',sortable:true,label: 'Org Type'},
        {key: 'createddate',sortable:true,label: 'Created Date'},
        {key: 'action',label: 'Action'}
      ],
      isBusy: false,
      lastPerPage: 5,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      pageOptions: [ 5, 25, 50, 100 ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      modalInfo: { title: '', content: '' }
    }
  },
  computed: {
    ...mapGetters(["getRecordTotal", "getRecords"])
  },      
  methods: {
    ...mapActions('org', ['getList','delById']),
    myProvider(ctx){
      this.isBusy = true
      if(this.lastPerPage != ctx.perPage){
        this.lastPerPage = ctx.perPage;
        ctx.currentPage = 1;
      }
      var startVal = (ctx.currentPage-1) * ctx.perPage
      ctx['start'] = startVal
      ctx['length'] = ctx.perPage
      this.itemsData = [];
      let promise = this.$store.dispatch('getList',{ url:'organization/index', data: ctx })
      let itemsx = []
      return promise.then((res) => {
          itemsx = this.$store.state.org.records
          this.totalRows = this.$store.state.org.recordTotal
          return(itemsx)
      })
      return(itemsx)
    },
    info (item) {
        this.$router.push('/org/edit/'+item.orgindex)
    },
    add () {
        this.$router.push('/org/add')
    },
    del(item) {
        this.$swal({
            title: 'Are you sure?',
            text: 'You want to remove this organization!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
          }).then((result) => {
            if (result.value) {
                this.$store.dispatch('delById', {url:'organization/removeOrg',data : { 'orgIndex':item.orgindex }}).then((res) => {
                  this.$root.$emit('bv::refresh::table', 'orgtable');
                  this.$swal('Deleted!',getResponseMessages(res.data.messages),'success')
                },(error) =>{
                  this.$swal('Cancelled',getResponseMessages(error.data.messages),'error')
                });
            }
          })
    }  
  }
}
</script>